import type { Refund as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import { RefundKind } from './RefundKind';
import * as RefundLine from './RefundLine';

/** A refund issued against an order, with the tickets and order-level charges it returned. */
export type Refund = {
  id: number;
  amount: number;
  donation: number;
  processingFee: number;
  taxFee: number;
  kind: RefundKind;
  reason?: string;
  issuedBy?: string;
  lines: RefundLine.RefundLine[];
};

export const fromGql = (item: GQLItem): Refund => ({
  ...take<Refund>(item, 'id', 'amount', 'donation', 'processingFee', 'taxFee', 'kind', 'reason', 'issuedBy'),
  lines: item.lines.map(RefundLine.fromGql),
});
